import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { PopupDialogStyle } from "./style";

function PopupDialog({
  open,
  onClose,
  title,
  content,
  maxWidth = "sm",
  fullWidth = true,
  showCloseIcon = true,
  disableBackdropClose = false,
  confirmLabel,
  onConfirm,
  confirmColor = "primary",
  confirmVariant = "contained",
  confirmDisabled = false,
  cancelLabel,
  onCancel,
  cancelColor = "primary",
  cancelVariant = "outlined",
}) {
  const classes = PopupDialogStyle();
  const [scroll] = useState("body");
  const handleBackdropClose = (_, reason) => {
    if (disableBackdropClose && reason === "backdropClick") return;
    onClose?.();
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    else onClose?.();
  };
  return (
    <Dialog
      open={open}
      onClose={handleBackdropClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      scroll={scroll}
      aria-labelledby="popup-dialog-title"
      className={classes.customModal}
    >
      <div className={"dialogTitle"}>
        <Typography
          id="popup-dialog-title"
          variant="h6"
          className={"titleText"}
        >
          {title}
        </Typography>

        {showCloseIcon && (
          <IconButton
            aria-label="close"
            className={"closeButton"}
            onClick={onClose}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </div>
      <DialogContent className={"dialogContent"}>
        {typeof content === "string" ? (
          <Typography variant="body1">{content}</Typography>
        ) : (
          content
        )}
      </DialogContent>

      <DialogActions>
        {cancelLabel && (
          <Button
            onClick={handleCancel}
            color={cancelColor}
            variant={cancelVariant}
          >
            {cancelLabel}
          </Button>
        )}

        {confirmLabel && (
          <Button
            onClick={onConfirm}
            color={confirmColor}
            variant={confirmVariant}
            disabled={confirmDisabled}
            className="orange-btn primary-btn center-loading-indicator"
          >
            {confirmLabel}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
export default PopupDialog;
